module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/metal-detector/display1.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/metal-detector/display1.png
// module id = 589
// module chunks = 0